import React from 'react';
import { Chip } from '@mui/material';
import { CircleRounded as CircleIcon } from '@mui/icons-material';

const StatusLabel = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'draft':
        return {
          label: '準備中',
          color: 'default',
          icon: <CircleIcon fontSize="small" />
        };
      case 'published':
        return {
          label: '公開中',
          color: 'success',
          icon: <CircleIcon fontSize="small" />
        };
      default:
        return {
          label: '準備中',
          color: 'default',
          icon: <CircleIcon fontSize="small" />
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size="big"
      variant="filled"
      className='m-1'
    />
  );
};

export default StatusLabel;